import { Component, OnInit } from '@angular/core';
import { SystemUnavailService } from '../services/systemunavail/systemunavail.service';
import { ReturnObject } from '../models/returnObject';
import { StatusMessagesService } from '../services/statusmessage.service';
import { InternalMsgService } from '../services/internal.msg.service';
import { AccountService } from '../services/account.service';
import { AccountItem } from '../models/accountitem';
import { Router } from '@angular/router';

@Component( {
  selector: 'app-systemunavail',
  templateUrl: './systemunavail.component.html',
  styleUrls: ['./systemunavail.component.scss']
} )
export class SystemUnavailComponent implements OnInit {

    message: string = 'STR is currently undergoing maintenance. Please check in later.'
    spinnerMessage: string = '';

    constructor(private systemUnavailService: SystemUnavailService,
        private msgService: InternalMsgService,
        private accountService: AccountService,
        private router: Router,
        private statusMessagesService: StatusMessagesService) { }

    ngOnInit() {
        this.getAvailMessage();
    } 

    getAvailMessage() : void {
        this.msgService.ontoggleSpinnerSet(true);
        this.systemUnavailService.getAvailMessage()
            .subscribe( { 
                next: (data: ReturnObject<string>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.message = data.value;
                    if (this.accountService.getAccount().isSystemAilable) {
                        this.router.navigate( ['/home']);
                    } else {
                        const accItem = new AccountItem();
                        accItem.isSystemAilable = false;
                        this.accountService.setAccount(accItem)
                    }
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }
}
